import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductPriceXPriceGroup } from "src/models/Products/Product.models";

interface ProductPriceXPriceGroupState {
  productPriceXPriceGroups: IProductPriceXPriceGroup[];
  productPriceXPriceGroupToEdit: IProductPriceXPriceGroup | null;
}

const initialState: ProductPriceXPriceGroupState = {
  productPriceXPriceGroups: [],
  productPriceXPriceGroupToEdit: null,
};

const ProductPriceXPriceGroupSlice = createSlice({
  name: "ProductPriceXPriceGroup",
  initialState,
  reducers: {
    setProductPriceXPriceGroupList: (
      state,
      action: PayloadAction<IProductPriceXPriceGroup[]>
    ) => {
      state.productPriceXPriceGroups = action.payload;
    },
    setProductPriceXPriceGroupToEdit: (
      state,
      action: PayloadAction<IProductPriceXPriceGroup | null>
    ) => {
      state.productPriceXPriceGroupToEdit = action.payload;
    },
    addProductPriceXPriceGroup: (
      state,
      action: PayloadAction<IProductPriceXPriceGroup>
    ) => {
      state.productPriceXPriceGroups.push(action.payload);
    },
    updateProductPriceXPriceGroup: (
      state,
      action: PayloadAction<IProductPriceXPriceGroup>
    ) => {
      let itemIndex = state.productPriceXPriceGroups.findIndex(
        item =>
          item.productPriceXPriceGroupId ===
          action.payload.productPriceXPriceGroupId
      );
      if (itemIndex !== -1)
        state.productPriceXPriceGroups[itemIndex] = action.payload;
    },
    updateUnitPriceProductPrice: (state, action: PayloadAction<IProductPriceXPriceGroup>) => {
      let itemIndex = state.productPriceXPriceGroups.findIndex(
        item => item.productId === action.payload.productId
      );
      if (itemIndex !== -1) {
        state.productPriceXPriceGroups[itemIndex].unitPrice = action.payload.unitPrice;
      }
    },
    updateUnitPriceProductPriceEditing: (state, action: PayloadAction<IProductPriceXPriceGroup>) => {
      if (state.productPriceXPriceGroupToEdit) {
        state.productPriceXPriceGroupToEdit.unitPrice = action.payload.unitPrice;
        state.productPriceXPriceGroupToEdit.unitPriceWithVAT = action.payload.unitPriceWithVAT;
      }
    },
    deleteProductPriceXPriceGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.productPriceXPriceGroups.filter(
        item => item.productPriceXPriceGroupId !== action.payload
      );
      state.productPriceXPriceGroups = newArray;
    },
  },
});

export const {
  setProductPriceXPriceGroupList,
  setProductPriceXPriceGroupToEdit,
  addProductPriceXPriceGroup,
  updateProductPriceXPriceGroup,
  updateUnitPriceProductPrice,
  updateUnitPriceProductPriceEditing,
  deleteProductPriceXPriceGroup,
} = ProductPriceXPriceGroupSlice.actions;

export default ProductPriceXPriceGroupSlice.reducer;
